/**
 * Created by maximus on 14.10.16.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _dec, _class, _class2, _temp;

var _reactRedux = require('react-redux');

var _reactRouter = require('react-router');

var _textEllipsis = require('text-ellipsis');

var _textEllipsis2 = _interopRequireDefault(_textEllipsis);

var _components2 = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    Product: {
        displayName: 'Product'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Products/default/Product.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var Product = _wrapComponent('Product')((_dec = (0, _reactRedux.connect)(function (state) {
    return {
        currency: state.currency,
        orderInOneClick: state.setting.orderInOneClick,
        buyInCreditActive: state.setting.buyInCreditActive
    };
}), _dec(_class = (_temp = _class2 = function (_Component) {
    (0, _inherits3.default)(Product, _Component);

    function Product(props) {
        (0, _classCallCheck3.default)(this, Product);
        return (0, _possibleConstructorReturn3.default)(this, (Product.__proto__ || (0, _getPrototypeOf2.default)(Product)).call(this, props));
    }

    (0, _createClass3.default)(Product, [{
        key: 'getRemainder',
        value: function getRemainder(nestedOffer, quantityTechCard, product_detail) {
            if (nestedOffer.childOffer === null) {
                return null;
            }
            if (nestedOffer.quantity > 0) {
                var quantity = void 0;
                quantity = nestedOffer.quantity;
                if (nestedOffer.childOffer.modifier_option_id !== null) {
                    nestedOffer.childOffer.modOption = nestedOffer.childOffer.modifiedOption.reduce(function (mod, modifier) {
                        if (modifier.id === nestedOffer.childOffer.modifier_option_id) {
                            return modifier;
                        }
                        return mod;
                    }, null);
                    if (nestedOffer.childOffer.modOption !== null && nestedOffer.childOffer.type_id !== 5) {
                        nestedOffer.childOffer.unit = nestedOffer.childOffer.modOption.unit;
                        if (nestedOffer.childOffer.modOption.storable === true && nestedOffer.childOffer.modOption.storage_strict) {
                            product_detail.storable = true;
                            if (nestedOffer.childOffer.modOption.remainder.length === 0) {
                                product_detail.remainder = [{ quantity: 0 }];
                            } else if (nestedOffer.childOffer.modOption.remainder[0].quantity > 0) {
                                if ((nestedOffer.childOffer.modOption.unit_id === 2 || nestedOffer.childOffer.modOption.unit_id === 8) && nestedOffer.childOffer.modOption.weight && nestedOffer.childOffer.modOption.weight > 0) {
                                    quantity = nestedOffer.childOffer.modOption.weight * nestedOffer.quantity;
                                }
                                quantityTechCard = Math.floor(nestedOffer.childOffer.modOption.remainder[0].quantity / quantity);
                                if (product_detail.remainder.length === 0 || product_detail.remainder[0].quantity > quantityTechCard) {
                                    product_detail.remainder = [{ quantity: quantityTechCard }];
                                }
                            } else {
                                product_detail.remainder = [{ quantity: 0 }];
                            }
                        }
                    }
                }
                if (nestedOffer.childOffer.modOption === null || nestedOffer.childOffer.type_id === 5) {
                    if (nestedOffer.childOffer.storable === true && nestedOffer.childOffer.storage_strict) {
                        product_detail.storable = true;
                        if (nestedOffer.childOffer.remainder.length === 0) {
                            product_detail.remainder = [{ quantity: 0 }];
                        } else if (nestedOffer.childOffer.remainder[0].quantity > 0) {
                            if ((nestedOffer.childOffer.unit_id === 2 || nestedOffer.childOffer.unit_id === 8) && nestedOffer.childOffer.weight && nestedOffer.childOffer.weight > 0) {
                                quantity = nestedOffer.childOffer.weight * nestedOffer.quantity;
                            }
                            quantityTechCard = Math.floor(nestedOffer.childOffer.remainder[0].quantity / quantity);
                            if (product_detail.remainder.length === 0 || product_detail.remainder[0].quantity > quantityTechCard) {
                                product_detail.remainder = [{ quantity: quantityTechCard }];
                            }
                        } else {
                            product_detail.remainder = [{ quantity: 0 }];
                        }
                    }
                }
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var currency = this.props.currency;
            var _props$data = this.props.data,
                id = _props$data.id,
                price = _props$data.price,
                name = _props$data.name,
                pictures = _props$data.pictures;


            var cartButtonClassName = 'add-cart-button add-to-cart';
            var cartProductClassName = 'col-sm-6 col-md-4 no-margin product-item-holder hover';
            if (this.props.orderInOneClick && this.props.buyInCreditActive && price <= 500000 && price >= 3000) {
                cartButtonClassName = 'add-cart-button-three  add-to-cart';
                cartProductClassName = 'col-sm-6 col-md-4 no-margin product-item-holder hover credit';
            }
            price = parseFloat(price);
            var imgSrc = '/assets/images/placeholder.png';
            if (pictures[0]) {
                if (pictures[0].preview_url) {
                    imgSrc = pictures[0].preview_url;
                } else {
                    if (pictures[0].url) {
                        imgSrc = pictures[0].url;
                    }
                }
            }
            if (this.props.data.type_id === 5) {
                this.props.data.storable = false;
                this.props.data.storage_strict = true;
                this.props.data.remainder = [];
                var quantityTechCard = 1;
                var priceComponent = 0;
                var modifierComponent = null;
                var modifierComponentTwo = null;
                var storableComponent = false;
                this.props.data.is_quantity_change = false;
                this.props.data.nestedOffers.forEach(function (nestedOffer) {
                    if (nestedOffer.quantity > 0 && nestedOffer.childOffer) {
                        modifierComponent = null;
                        if (nestedOffer.childOffer.type_id === 5) {
                            nestedOffer.childOffer.remainder = [];
                            nestedOffer.childOffer.nestedOffers.forEach(function (nestedOfferTwo) {
                                _this2.getRemainder(nestedOfferTwo, nestedOffer.quantity, _this2.props.data);
                            });
                        } else {
                            _this2.getRemainder(nestedOffer, quantityTechCard, _this2.props.data);
                        }
                    }
                    if (nestedOffer.is_quantity_change) {
                        _this2.props.data.is_quantity_change = true;
                    }
                });
                price = parseFloat(this.props.data.price);
                if (this.props.data.modifier_option_id !== undefined) {
                    this.props.data.modifier_option.storable = this.props.data.storable;
                    this.props.data.modifier_option.remainder[0] = this.props.data.remainder[0];
                }
            }

            return _react3.default.createElement(
                'div',
                { className: cartProductClassName },
                _react3.default.createElement(
                    'div',
                    { className: 'product-item flying-to-cart-holder' },
                    _react3.default.createElement(_components2.ProductWishIcon, { product: this.props.data, inCard: true }),
                    _react3.default.createElement(
                        'div',
                        { className: 'image' },
                        _react3.default.createElement(
                            _reactRouter.Link,
                            { to: '/product/' + id },
                            _react3.default.createElement('img', { className: 'flying-to-cart-img', alt: '', src: imgSrc })
                        )
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'body' },
                        _react3.default.createElement('div', { className: 'label-discount clear' }),
                        _react3.default.createElement(
                            'div',
                            { className: 'title text-center' },
                            _react3.default.createElement(
                                _reactRouter.Link,
                                { to: '/product/' + id },
                                _react3.default.createElement(
                                    'span',
                                    { className: 'visible-lg text-theme-color' },
                                    (0, _textEllipsis2.default)(name, 160, { ellipsis: '...' })
                                ),
                                _react3.default.createElement(
                                    'span',
                                    { className: 'hidden-lg hidden-xs text-theme-color' },
                                    (0, _textEllipsis2.default)(name, 80, { ellipsis: '...' })
                                ),
                                _react3.default.createElement(
                                    'span',
                                    { className: 'visible-xs text-theme-color' },
                                    (0, _textEllipsis2.default)(name, 120, { ellipsis: '...' })
                                )
                            )
                        )
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'prices' },
                        _react3.default.createElement(
                            'div',
                            { className: 'price-current text-center text-theme-color' },
                            _react3.default.createElement(_components2.MoneyValue, {
                                value: price,
                                icon: currency.icon,
                                iconAfterValue: currency.icon_after_value
                            })
                        )
                    ),
                    _react3.default.createElement(
                        'div',
                        { className: 'hover-area' },
                        _react3.default.createElement(
                            'div',
                            { className: cartButtonClassName },
                            _react3.default.createElement(_components2.AddToBasket, { product: this.props.data })
                        )
                    )
                )
            );
        }
    }]);
    return Product;
}(_react2.Component), _class2.propTypes = {
    data: _react2.PropTypes.object.isRequired,
    currency: _react2.PropTypes.object
}, _temp)) || _class));

exports.default = Product;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Products/default/Product.jsx
// module id = 1739
// module chunks = 0